import React from 'react';
import styles from './drawer-header.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { DrawerHandle } from 'components/atomic/atoms/drawer-handle';

export interface DrawerHeaderProps {
  /**
   * Whether to show the drawer handle
   * @default true
   */
  showHandle?: boolean;
  
  /**
   * Content to display in the header
   */
  children: React.ReactNode;
  
  /**
   * Additional CSS class name
   */
  className?: string;
}

/**
 * DrawerHeader - A header component for drawers with optional handle
 * 
 * This is a generic molecule component that composes DrawerHandle with a content area.
 * It has no domain knowledge and can be used for any drawer header.
 * 
 * @example
 * ```tsx
 * <DrawerHeader>
 *   <h3>3,265+ Homes in Tampa, FL</h3>
 * </DrawerHeader>
 * 
 * <DrawerHeader showHandle={false}>
 *   <div>Custom content without handle</div>
 * </DrawerHeader>
 * ```
 */
export function DrawerHeader({
  showHandle = true,
  children,
  className,
}: DrawerHeaderProps) {
  return (
    <div className={buildClassName(styles.header, className)}>
      {showHandle && <DrawerHandle />}
      <div className={styles['header-content']}>
        {children}
      </div>
    </div>
  );
}
